import { render, staticRenderFns } from "./purchasingAddList.vue?vue&type=template&id=ffcb6552&scoped=true"
import script from "./purchasingAddList.vue?vue&type=script&lang=js"
export * from "./purchasingAddList.vue?vue&type=script&lang=js"
import style0 from "./purchasingAddList.vue?vue&type=style&index=0&id=ffcb6552&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffcb6552",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ffcb6552')) {
      api.createRecord('ffcb6552', component.options)
    } else {
      api.reload('ffcb6552', component.options)
    }
    module.hot.accept("./purchasingAddList.vue?vue&type=template&id=ffcb6552&scoped=true", function () {
      api.rerender('ffcb6552', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/purchasingManagement/purchasingAddList.vue"
export default component.exports